import React from 'react'
import ReactPlaceholder from 'react-placeholder'
import styled from 'styled-components'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Card from '@material-ui/core/Card'

const LargeCard = styled(Card)`
  display: flex;
  padding: 15px;
  flex-wrap: wrap;
  background-color: #fff;
  position: relative;
`

const CardWrapper = styled(Card)`
  height: 100%;
  padding: 15px;
  position: relative;
`

const randomRows = () => Math.floor(Math.random() * 4) + 3

const LoadingPlaceholder = ({ index }) => {
  const isDefaultBreakpoint = useMediaQuery('(min-width: 1050px)');

  return index === 0 && isDefaultBreakpoint ? (
    <>
      <LargeCard>
        <ReactPlaceholder showLoadingAnimation ready={false} type="rect" style={{ width: '50%' }} />
        <div style={{ height: '388px', width: '45%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          <ReactPlaceholder showLoadingAnimation ready={false} type="rect" style={{ height: '32px', width: '100%', marginBottom: '25px' }} />
          <ReactPlaceholder showLoadingAnimation ready={false} type="text" rows={randomRows()} />
        </div>
        <ReactPlaceholder
          showLoadingAnimation
          ready={false}
          type="text"
          rows={1}
          style={{ width: '100px', position: 'absolute', bottom: 30, right: 30 }}
        />
      </LargeCard>
    </>
  ) : (
    <CardWrapper>
      <div style={{ height: '375px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <ReactPlaceholder showLoadingAnimation ready={false} type="rect" style={{ height: '120px', marginBottom: '25px' }} />
        <ReactPlaceholder showLoadingAnimation ready={false} type="text" rows={randomRows()} />
      </div>
      <ReactPlaceholder
        showLoadingAnimation
        ready={false}
        type="text"
        rows={1}
        style={{ width: '100px', position: 'absolute', bottom: 30, right: 30 }}
      />
    </CardWrapper>
  )
}

export default LoadingPlaceholder
